import { OccasionPage } from "@/components/public/OccasionPage"
import heroWedding from "@/images/hero-wedding.webp"
import labelClub from "@/images/label-club.webp"
import labelSchool from "@/images/label-school.webp"

const DESCRIPTION =
  "Wedding wine labels with your names, date and design, on South African wine for the tables or as wedding wine favours, delivered throughout the UK."

export default function Weddings() {
  return (
    <OccasionPage
      title="Weddings"
      metaTitle="Wedding Wine Labels & Favours"
      description={DESCRIPTION}
      lede="Your names, your date and your design on the wine poured at your wedding breakfast."
      heroImage={{
        src: heroWedding,
        alt: "Bespoke wedding wine label on a bottle at a table setting",
        width: 1072,
        height: 1600,
      }}
      story={{
        eyebrow: "Weddings",
        heading: "Your names, your date, your table",
        paragraphs: [
          "The wine on your table can carry more than a vintage — it can carry your names, your wedding date and a design that means something to the two of you. Guests take a bottle home and keep it long after the day itself.",
          "We work from your ideas, a monogram, a photograph, or simply your names and date, and turn it into a label proof for you to approve before a drop is poured.",
        ],
      }}
      cellar={{
        lede: "A small selection of bespoke bottles produced for clubs, schools and clubhouses across the United Kingdom.",
        bottles: [
          {
            src: labelClub,
            alt: "Members' club commemorative bottle",
            name: "Members' Club",
            place: "London",
          },
          {
            src: labelSchool,
            alt: "School foundation commemorative bottle",
            name: "Foundation Dinner",
            place: "Surrey",
          },
        ],
      }}
    />
  )
}
